import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { LeftArrowWhite } from '../../assets/images/svg/LeftArrow'
import { observer } from 'mobx-react'
import { applicationStore } from 'src/store/ApplicationStore'
import { toast } from 'react-toastify'
import Preloader from 'src/components/ui/Preloader'
import { workflowStepIterator } from 'src/services/workflowStepIterator'
import { NodeTypes } from 'src/enums/NodeTypes'
import { parseServiceErrorMessage } from 'src/helpers/parseServiceError'
import { useTranslation } from 'react-i18next'

const EidVerification = observer(() => {
    const [submitting, setSubmitting] = useState(false)
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleContinue = async () => {
        try {
            setSubmitting(true)
            const response = await workflowStepIterator({
                access_token: applicationStore.access_token,
                node_id: applicationStore.workflowNextServiceResponse.node_id,
                body: {
                    "plato": "plato"
                },
                action_index: 0,
                constextOfStep: { step: NodeTypes.EID_VERIFICATION, "retry": applicationStore.workflowNextServiceResponse.retry }
            })
            if (response.data?.service_results[0].status !== 200) {
                const rawMessage = response.data?.service_results[0]?.message;
                const parsedMessage = parseServiceErrorMessage(rawMessage);
                throw new Error(parsedMessage);
            }
            const serviceData = response.data?.service_results[0].data;
            const link = serviceData?.authorization_url;
            if (link) {
                applicationStore.setWorkflowNextServiceResponse({ ...response.data, index: 1 });
                localStorage.setItem("ApplicationStore", JSON.stringify(applicationStore));
                window.location.replace(link);
                return;
            }
            applicationStore.setWorkflowNextServiceResponse(response.data);
            navigate("/next", { replace: true });
        } catch (error) {
            setSubmitting(false);
            toast.error(error?.message || t('eidVerification.error'));
        }
    }

    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full">
                <div>
                    <div className='text-left'>
                        <Button className="" variant="primaryBack" onClick={() => { navigate(`/?aid=${applicationStore.aidCode}`, { replace: true }) }}><LeftArrowWhite /></Button>
                    </div>
                    <div className='grid gap-[16px] mt-10'>
                        <div className="text-h5 font-bold text-flow-heading">{t('eidVerification.title')}</div>
                        <div className="text-body text-Gray900">{t('eidVerification.description')}</div>
                    </div>
                    <div className='mt-6'>
                        <Button className="mt-4" variant="primaryWithoutIcon" disabled={submitting} onClick={handleContinue}>
                            <span className="me-1">{t('actions.continue')}</span>{submitting && <Preloader variant='white' />}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default EidVerification
